import React, { useEffect } from 'react';

const Toast = ({ type = 'info', message, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (!duration) return;
    const t = setTimeout(() => onClose && onClose(), duration);
    return () => clearTimeout(t);
  }, [duration, onClose]);

  const base = 'px-4 py-3 rounded-lg shadow-lg text-sm sm:text-base border';
  const color =
    type === 'success'
      ? 'bg-green-900/80 border-green-600 text-green-100'
      : type === 'error'
      ? 'bg-red-900/80 border-red-600 text-red-100'
      : 'bg-dark-700 border-dark-500 text-white';

  return (
    <div className={`fixed bottom-6 right-6 z-50 ${base} ${color} flex items-center gap-3`}> 
      <span>{message}</span>
      <button onClick={onClose} className="text-white/80 hover:text-white">✕</button>
    </div>
  );
};

export default Toast;


